import React from 'react';
import cx from 'classnames';

import CardsVariation from 'iovisit-theme/components/Blocks/Listing/CardsTemplate/Cards';

interface RelatedItemsProps {
  className: string;
  background: boolean;
  items: [];
  title: string;
}

const RelatedItems: React.FC<RelatedItemsProps> = ({
  items = [],
  className,
  background = false,
  title,
}) => {
  return items?.length > 0 ? (
    <div
      className={cx('related-items', {
        [className]: className != null,
      })}
    >
      <div className="block listing">
        <CardsVariation
          show_block_bg={background}
          title={title}
          items={items}
        />
      </div>
    </div>
  ) : null;
};

export default RelatedItems;
